<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('especificacoes')">Especificações</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ title }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-10 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.descricao" :error="form.errors.descricao" class="pr-6  w-full" maxlength="100" label="Descricão" />
          <div class="w-full py-4"><p class="font-medium">Requer atenção de qual setor?</p></div>

          <checkbox v-model="form.desenvolvimento" class="w-1/3" true-value="S" false-value="N" label="Desenvolvimento" />

          <checkbox v-model="form.comercial" class="w-1/3" true-value="S" false-value="N" value="S" label="Comercial" />
          <checkbox v-model="form.implantacao" class="w-1/3" true-value="S" false-value="N" value="S" label="Implantação" />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <button v-if="editMode" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Apagar</button>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit"> {{ submitTextButton }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from '../../Shared/Checkbox.vue'

export default {
  name: 'CreateOrEdit',
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    Checkbox,
  },
  layout: Layout,
  props: {
    especificacao: {
      type: Object,
      default() {
        return {}
      },
    },
    modulos: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
      imgDataUrl: '',
      form: this.$inertia.form({
        idEspecificacao: null,
        descricao: null,
        desenvolvimento: 'N',
        comercial: 'N',
        implantacao: 'N',
      }),
    }
  },
  computed: {
    title() {
      return this.especificacao.idEspecificacao ? 'Editar' : 'Criar'
    },
    editMode() {
      return this.especificacao.idEspecificacao ? true : false
    },
    submitTextButton() {
      return this.especificacao.idEspecificacao ? 'Atualizar' : 'Criar'
    },

  },
  created(){
    if(this.editMode){
      this.form = {...this.form, ...this.especificacao}
    }
  },
  remember: 'form',
  methods: {
    submit(){
      if(this.editMode){
        this.update()
      }else{
        this.store()
      }
    },
    store() {
      this.form.post(this.route('especificacoes.store'))
    },
    update() {
      this.form.put(this.route('especificacoes.update', this.especificacao.idEspecificacao))
    },
    destroy() {
      if (confirm('Você deseja mesmo apagar essa especificação?')) {
        // this.$inertia.delete(this.route('organizations.destroy', this.especificacao.idEspecificacao))
      }
    },

  },
}
</script>
